import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, OnInit } from '@angular/core';

import { MarqueeBackgroundContainerConfig, TitleIconOptions } from '@frontend/sports/types/components/content';
import { MarqueeLink } from '@frontend/sports/types/components/widget/types';

import { MarqueeTitleIcon } from './marquee-tile.model';
import { MarqueeTrackingService } from './marquee-tracking.service';

@Component({
    selector: 'ms-header',
    templateUrl: 'header.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit, OnChanges {
    @Input() titleIcon: MarqueeTitleIcon;
    @Input() backgroundContainerConfig: MarqueeBackgroundContainerConfig;
    @Input() globalLinkConfig: MarqueeLink;
    @HostBinding('class') className = 'marquee-header';

    title: string | undefined;
    globalLinkText: string | undefined;
    globalLink: string | undefined;
    globalLinkCount: number | undefined;

    constructor(private marqueeTrackingService: MarqueeTrackingService) {}
    checkTitleIcon: boolean;

    ngOnInit(): void {
        this.updateChanges();
    }

    ngOnChanges(): void {
        this.updateChanges();
    }

    private updateChanges(): void {
        this.title = this.backgroundContainerConfig.title ?? '';
        this.globalLinkText = this.globalLinkConfig.title;
        this.globalLink = this.globalLinkConfig.linkOverride;
        this.checkTitleIcon = this.backgroundContainerConfig.titleIconDisplay === TitleIconOptions.CompetitionLogo;
    }

    linkClick(): void {
        this.marqueeTrackingService.trackLinkClick(this.globalLink);
    }

    isRequiredTitleIcon(): boolean | undefined {
        return this.backgroundContainerConfig.titleIconDisplay && this.backgroundContainerConfig.titleIconDisplay !== TitleIconOptions.None;
    }
}
